interface ServiceCard {
  icon: string;
  title: string;
  description: string;
}

const services: ServiceCard[] = [
  {
    icon: 'ri-stack-line',
    title: 'Architecture & System Design',
    description: 'Clean, layered architecture patterns that ensure long-term maintainability and enable seamless feature evolution across the iOS platform.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Performance & Optimization',
    description: 'Deep-level profiling and optimization techniques that maximize responsiveness, reduce resource consumption, and deliver fluid user interactions.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Process & Innovation',
    description: 'Continuously refined development workflows and adoption of modern engineering standards to keep every project at the cutting edge of technical excellence.',
  },
];

export default function ServicesSection() {
  return (
    <section className="w-full py-24 md:py-32 px-10 md:px-16 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto flex flex-col items-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 text-secondary-700 text-xs font-medium tracking-widest uppercase">
          Capabilities
        </span>

        <h2 className="mt-6 text-4xl md:text-5xl font-bold text-foreground-950 text-center leading-tight">
          What We Do Best
        </h2>

        <p className="mt-5 text-lg text-foreground-500 text-center max-w-xl leading-relaxed">
          Focused expertise across the full spectrum of modern iOS software engineering.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
          {services.map((service) => (
            <div
              key={service.title}
              className="group p-8 rounded-2xl bg-background-50 transition-colors duration-300 hover:bg-accent-50/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-6">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-foreground-900 leading-snug">
                {service.title}
              </h3>
              <p className="mt-4 text-base text-foreground-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}